<!-- component/Navbar.svelte -->
<header class="navbar">
  <div class="container">
    <div class="navbar-brand">
      <div class="navbar-item">
        <img src="favicon.png" alt="Logo" />
      </div>
    </div>
    <div class="navbar-menu">
      <div class="navbar-end">
        <span class="navbar-item">
          <a
            class="button is-success is-inverted"
            href="https://github.com/wormwlrm/svelte-todo-list"
            target="_blank"
          >
            <span class="icon">
              <i class="fab fa-github"></i>
            </span>
            <span>Github</span>
          </a>
        </span>
      </div>
    </div>
  </div>
</header>
